import { CommonService } from '@app/shared/common/common.service';
import { Component, OnInit } from '@angular/core';
import { CartService } from "./cart.service";
import { Router } from "@angular/router";
import { I18nService } from '@app/shared/i18n/i18n.service';
import { AppState } from "@app/app.service";
import { environment } from '@env/environment';

declare var $: any;

@Component({
  selector: 'sa-cart',
  templateUrl: './cart.component.html',
  providers: [CartService]
})
export class CartComponent implements OnInit {
  count: number;
  showCart:boolean;
  public currentLanguage: any;

  constructor(
		private cartService: CartService,
		private router: Router,
		private i18nService: I18nService,
		private appService: AppState,
		private commonService: CommonService
  ) {

    this.count = 0;
	this.currentLanguage = this.i18nService.currentLanguage;
	this.appService.cartUpdate.subscribe(data => { 
		if(data !== null && data !== undefined) {
			// Optimistic update: adjust count immediately
			if (typeof data === 'number') {
				this.count = Math.max(0, this.count + data);
			}
			// Then sync with server
			this.getCartCount();	
		}
	})
  }

  ngOnInit() {
	// let rights = this.commonService.getCookie(environment.userRights) ? 
	// 			JSON.parse(this.commonService.decrypt(decodeURIComponent(this.commonService.getCookie(environment.userRights)))).userRights :
	// 			this.commonService.logout();
	let rights = localStorage.getEncryptedItem('userRights') || this.commonService.logout();

	let rightsArray = rights.split(',')  
	this.showCart=rightsArray.includes('ngtMPur');
	if(this.showCart){
	this.getCartCount();
	}	
  }

  getCartCount() {
		let data = new FormData();
		data.append('instanceId',localStorage.getEncryptedItem('instanceId'));
		data.append('userId',localStorage.getEncryptedItem('loginId'));
		data.append("language", this.commonService.getCurrentLanguageCode());
		data.append('companyId',localStorage.getEncryptedItem('companyId'));
		data.append("loggedInTime", localStorage.getEncryptedItem("loggedInTime"));
		data.append("lastRequestTime", localStorage.getEncryptedItem("lastRequestTime"));
		var object = this.commonService.createObject(data)
		let token = this.commonService.createToken(object)
		let encryptedToken = this.commonService.encrypt(token)
		let encrData = new FormData()
		encrData.append("encrToken", encryptedToken);
		this.cartService.getBasketList(encrData).subscribe((data:any) =>{ 
			this.count = data.data.items.length;
			console.log('Cart count updated:', this.count);
		}, (error) => {
			console.error('Error updating cart count:', error);
		})
  }

  onToggle() {
    this.router.navigate(['/purchase/cart']);
  }
}
